(() => {
  const initXtoolFeatures = (section) => {
    if (!section || section.dataset.xtoolInitialized === 'true') return;
    section.dataset.xtoolInitialized = 'true';

    const tabsWrapper = section.querySelector('.xtool-features__tabs-wrapper');
    const tabsContainer = section.querySelector('.xtool-features__tabs');
    const indicator = section.querySelector('.xtool-features__tab-indicator');
    const tabs = [...section.querySelectorAll('.xtool-features__tab[data-tab]')];
    const models = [...section.querySelectorAll('.xtool-features__models')];
    const panels = [...section.querySelectorAll('.xtool-features__gallery-panel')];

    let activeTab = 1;

    const updateIndicator = () => {
      if (!tabsContainer || !indicator) return;
      const activeBtn = tabs.find((tab) => Number(tab.dataset.tab) === activeTab);
      if (!activeBtn) return;

      const containerRect = tabsContainer.getBoundingClientRect();
      const btnRect = activeBtn.getBoundingClientRect();
      const left = btnRect.left - containerRect.left + tabsContainer.scrollLeft;
      indicator.style.left = `${left}px`;
      indicator.style.width = `${btnRect.width}px`;
    };

    const playActiveVideo = () => {
      section.querySelectorAll('video').forEach((video) => {
        video.pause();
        try { video.currentTime = 0; } catch (_) {}
      });
      const activeVideo = section.querySelector('.xtool-features__gallery-panel.is-active video');
      if (activeVideo) {
        activeVideo.muted = true;
        activeVideo.play().catch(() => {});
      }
    };

    const centerActiveTab = () => {
      if (!tabsWrapper || !tabsContainer) return;
      const activeBtn = tabs.find((tab) => Number(tab.dataset.tab) === activeTab);
      if (!activeBtn) return;
      const left = activeBtn.offsetLeft - (tabsContainer.clientWidth - activeBtn.offsetWidth) / 2;
      tabsContainer.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    };

    const setTab = (index, shouldScroll = true) => {
      activeTab = index;
      tabs.forEach((tab) => tab.classList.toggle('is-active', Number(tab.dataset.tab) === index));
      models.forEach((model, i) => model.classList.toggle('is-active', i + 1 === index));
      panels.forEach((panel, i) => panel.classList.toggle('is-active', i + 1 === index));
      requestAnimationFrame(() => {
        updateIndicator();
        if (shouldScroll) centerActiveTab();
        playActiveVideo();
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => setTab(Number(tab.dataset.tab), true));
    });

    let resizeFrame;
    const onResize = () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(updateIndicator);
    };
    window.addEventListener('resize', onResize, { passive: true });

    setTab(1, false);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-xtool-features]').forEach(initXtoolFeatures);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
